import type { ModelDefinition } from "@/models.js";

export const atlascloudModels = [
	{
		id: "kling-v3-0",
		name: "KLING v3.0",
		description:
			"AtlasCloud KLING v3.0 video generation. Routes text, image, duration, and 4K requests to the matching upstream KLING v3.0 model.",
		family: "atlascloud",
		output: ["video"],
		maxVideoDurationSeconds: 10,
		stability: "beta",
		releasedAt: new Date("2026-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "atlascloud",
				externalId: "kwaivgi/kling-v3.0",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.126",
					default_video: "0.084",
					"720p_audio": "0.126",
					"720p_video": "0.084",
					"1080p_audio": "0.168",
					"1080p_video": "0.112",
					"4k_audio": "0.42",
					"4k_video": "0.42",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: [
					"1280x720",
					"720x1280",
					"1920x1080",
					"1080x1920",
					"3840x2160",
					"2160x3840",
				],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "kling-v3-0-pro",
		name: "KLING v3.0 Pro",
		description:
			"AtlasCloud KLING v3.0 Pro video generation. Routes text and image requests to the matching upstream KLING v3.0 Pro model at 1080p.",
		family: "atlascloud",
		output: ["video"],
		maxVideoDurationSeconds: 10,
		stability: "beta",
		releasedAt: new Date("2026-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "atlascloud",
				externalId: "kwaivgi/kling-v3.0-pro",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.168",
					default_video: "0.112",
					"1080p_audio": "0.168",
					"1080p_video": "0.112",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "kling-v3-0-turbo",
		name: "KLING v3.0 Turbo",
		description:
			"AtlasCloud KLING v3.0 Turbo video generation. Routes text, image, and duration requests to the matching upstream KLING v3.0 Turbo model.",
		family: "atlascloud",
		output: ["video"],
		maxVideoDurationSeconds: 10,
		stability: "beta",
		releasedAt: new Date("2026-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "atlascloud",
				externalId: "kwaivgi/kling-v3.0-turbo",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.168",
					"720p_audio": "0.168",
					"1080p_audio": "0.21",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280", "1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: false,
			},
		],
	},
	{
		id: "veed-fabric-1-0",
		name: "VEED Fabric 1.0",
		description:
			"VEED Fabric 1.0 talking-video generation. Animates one image with a face into a lip-synced video driven by one speech audio track; the output is as long as the audio.",
		family: "atlascloud",
		output: ["video"],
		maxVideoDurationSeconds: 300,
		stability: "beta",
		releasedAt: new Date("2025-09-15"),
		providers: [
			{
				test: "skip",
				providerId: "atlascloud",
				externalId: "veed/fabric-1.0",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					"480p": "0.088",
					"720p": "0.165",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["854x480", "480x854", "1280x720", "720x1280"],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: false,
				videoDurationFollowsAudio: true,
			},
		],
	},
	{
		id: "veed-fabric-1-0-fast",
		name: "VEED Fabric 1.0 Fast",
		description:
			"VEED Fabric 1.0 Fast talking-video generation. Animates one image with a face into a lip-synced video driven by one speech audio track; the output is as long as the audio.",
		family: "atlascloud",
		output: ["video"],
		maxVideoDurationSeconds: 300,
		stability: "beta",
		releasedAt: new Date("2025-09-15"),
		providers: [
			{
				test: "skip",
				providerId: "atlascloud",
				externalId: "veed/fabric-1.0/fast",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					"480p": "0.11",
					"720p": "0.22",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["854x480", "480x854", "1280x720", "720x1280"],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: false,
				videoDurationFollowsAudio: true,
			},
		],
	},
] as const satisfies ModelDefinition[];
